import React from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { Constants } from '../utils';
import Menu from 'screens/menu';
import { RootState } from 'reducers';

const _Route = (props: any) => {
	const history = useHistory();
	const module_permissions = props.user?.module_permissions?.filter((i: any) => i.read).map((i: any) => i.module_id) || [];

	if (!props.user && (props.auth || props.admin || props.client)) {
		return <Redirect to="/login" />
	}
	if (props.user && props.admin && props.user.level_id != Constants.LEVELS.ADMIN && props.user.level_id != Constants.LEVELS.MODERATOR) {
		return <Redirect to="/" />
	}
	if (props.user && (props.user.level_id == Constants.LEVELS.MODERATOR || props.user.level_id == Constants.LEVELS.CLIENT_MODERATOR) && props.permission) {
		if (typeof props.permission === 'number') {
			if (module_permissions.indexOf(props.permission) == -1) {
				return <Redirect to="/" />
			}
		}
		else if (Array.isArray(props.permission)) {
			let value = false;
			props.permission.forEach((item: number) => {
				if (!value)
					value = module_permissions.indexOf(item) != -1;
			});
			if (!value) {
				return <Redirect to="/" />
			}
		}		
	}
	if (props.user && props.noAuth) {
		return <Redirect to="/" />
	}
	if (props.client && props.user.level_id != Constants.LEVELS.CLIENT && props.user.level_id != Constants.LEVELS.CLIENT_MODERATOR) {
		return <Redirect to="/" />
	}
	if (props.user && props.kyc && !props.user.has_kyc_plan) {
		return <Redirect to="/" />
	}
	if (props.user && props.documents && !props.user.has_document_plan) {
		return <Redirect to="/" />
	}
	if (props.user && props.bills && !props.user.has_bill_plan) {
		return <Redirect to="/" />
	}
	if (props.user && (props.auth || props.admin || props.client)) {
		return (
			<Menu history={ history }>
				<Route { ...props } />
			</Menu>
		)
	}

	return <Route { ...props } />
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(_Route);